import { useSection, useSendResponsible, useToast, useTracker } from '@/hooks';
import { object, string } from '@/utils/validations';

import { ResponsibleFormValues } from './types';

export const useResponsibleFormRules = () => {
  const { setSection } = useSection();
  const tracker = useTracker();
  const { sendResponsible } = useSendResponsible();
  const toast = useToast();

  const initialValues = {
    name: '',
    phone: '',
  };

  const validationSchema = object({
    name: string().name().required(),
    phone: string().telephoneOrCellphone().required(),
  });

  const handleSubmit = async (values: ResponsibleFormValues) => {
    await sendResponsible(values);
    tracker.dispatchWithUserData('risk_onboarding_form_contact_sent');
    toast.show({
      type: 'success',
      title: 'Recebemos os dados com sucesso!',
      description: 'Em breve entraremos em contato',
    });
    setSection('home');
  };

  const handleClickBack = () => setSection('home');

  return {
    handleClickBack,
    handleSubmit,
    validationSchema,
    initialValues,
  };
};
